var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-card-icons"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({value: _vm.tooltip, align: 'right', width: 240}),expression:"{value: tooltip, align: 'right', width: 240}"}],staticClass:"nexd-icon-32-delete",class:{disabled: !_vm.can_delete},attrs:{"aria-hidden":"true"},on:{"click":_vm.deleteFolder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }